/**
 * accounts.js
 * Quản lý danh sách tài khoản và credentials Nhanh.vn tương ứng.
 *
 * Để thêm tài khoản mới:
 *  1. Thêm entry vào mảng ACCOUNTS bên dưới
 *  2. Thêm biến môi trường tương ứng vào file .env
 */

export const ACCOUNTS = [
  {
    username: "admin",
    password: "admin123",
    role: "admin",
    displayName: "Admin Nhanh Anvy",
    /** Nhanh.vn credentials lấy từ biến môi trường của tài khoản admin */
    nhanhCredentials: {
      appId: process.env.REACT_APP_NHANH_APP_ID,
      businessId: process.env.REACT_APP_NHANH_BUSINESS_ID,
      accessToken: process.env.REACT_APP_NHANH_ACCESS_TOKEN,
    },
  },
  {
    username: "adminpcc",
    password: "pcc123",
    role: "adminpcc",
    displayName: "Admin Nhanh PCC",
    /** Nhanh.vn credentials lấy từ biến môi trường của tài khoản PCC */
    nhanhCredentials: {
      appId: process.env.REACT_APP_PCC_NHANH_APP_ID,
      businessId: process.env.REACT_APP_PCC_NHANH_BUSINESS_ID,
      accessToken: process.env.REACT_APP_PCC_NHANH_ACCESS_TOKEN,
    },
  },
];

/**
 * Xác thực tài khoản.
 * @param {string} username
 * @param {string} password
 * @returns {{ username, role, displayName, nhanhCredentials } | null}
 */
export function authenticateUser(username, password) {
  const account = ACCOUNTS.find(
    (acc) =>
      acc.username.trim().toLowerCase() === username.trim().toLowerCase() &&
      acc.password === password
  );

  if (!account) return null;

  // Trả về thông tin user (không bao gồm password)
  const { password: _pwd, ...safeAccount } = account;
  return safeAccount;
}

/**
 * Lấy Nhanh credentials từ thông tin user đã đăng nhập.
 * @param {{ nhanhCredentials?: object } | null} user
 * @returns {{ appId: string, businessId: string, accessToken: string }}
 */
export function getNhanhCredentials(user) {
  if (user?.nhanhCredentials) {
    return user.nhanhCredentials;
  }
  // Fallback về credentials mặc định (admin)
  return {
    appId: process.env.REACT_APP_NHANH_APP_ID,
    businessId: process.env.REACT_APP_NHANH_BUSINESS_ID,
    accessToken: process.env.REACT_APP_NHANH_ACCESS_TOKEN,
  };
}
